import React from 'react';
import {
  Box,
  Container,
  Heading,
  ListItem,
  SimpleGrid,
  Stack,
  UnorderedList,
} from '@chakra-ui/react';

/**
 * Macro-categorie con elenco idee CIL (non card proposte).
 * @param {Array<{ title: string, ideas: string[], highlight?: boolean }>} categories
 */
export default function LandingCategoryIdeasSection({
  theme,
  title,
  categories = [],
}) {
  if (!Array.isArray(categories) || !categories.length) return null;
  const { colors, fontHeading, fontBody } = theme;

  return (
    <Box bg={colors.surface} px={4} py={{ base: 10, md: 14 }}>
      <Container maxW="container.xl">
        <Stack spacing={8}>
          {title ? (
            <Heading
              as="h2"
              fontSize={{ base: '2xl', md: '3xl' }}
              fontFamily={fontHeading}
              color={colors.text}
            >
              {title}
            </Heading>
          ) : null}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
            {categories.map((cat) => {
              const ideas = Array.isArray(cat.ideas) ? cat.ideas : [];
              const isHighlight = Boolean(cat.highlight);
              return (
                <Box
                  key={cat.title}
                  bg={colors.bg}
                  borderRadius="2xl"
                  p={{ base: 5, md: 6 }}
                  borderWidth="2px"
                  borderColor={isHighlight ? colors.accent : colors.border}
                  borderLeftWidth={isHighlight ? '6px' : '2px'}
                  borderLeftColor={isHighlight ? colors.accent : colors.border}
                  boxShadow={
                    isHighlight
                      ? '0 16px 40px rgba(0,0,0,0.1)'
                      : '0 10px 24px rgba(0,0,0,0.06)'
                  }
                >
                  <Heading
                    as="h3"
                    fontSize={{ base: 'lg', md: 'xl' }}
                    fontFamily={fontHeading}
                    color={colors.text}
                    mb={4}
                  >
                    {cat.title}
                  </Heading>
                  <UnorderedList
                    spacing={2}
                    pl={1}
                    fontFamily={fontBody}
                    color={colors.text}
                    fontSize="sm"
                    fontWeight="600"
                    styleType="disc"
                  >
                    {ideas.map((idea) => (
                      <ListItem key={idea}>{idea}</ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              );
            })}
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
}
